import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhTw from 'element-plus/es/locale/lang/zh-tw'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import './styles/main.css'
import SvgIcon from './components/SvgIcon.vue'
import IconSelect from './components/IconSelect.vue'

const app = createApp(App)

// 全域註冊 Element Plus 圖示（工具列按鈕等仍會用到）
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全域註冊自建圖示庫元件（選單圖示一律走這裡）
app.component('SvgIcon', SvgIcon)
app.component('IconSelect', IconSelect)

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhTw })

app.mount('#app')
